import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Button, Form } from 'react-bootstrap';
import { useTranslation, Trans } from 'react-i18next';
import AppContext from 'context/Context';
import { forgetPassword } from 'y4/Falcon';

const ForgetPasswordForm = () => {
  // State
  const [email, setEmail] = useState('');
  const { t } = useTranslation('auth');
  const {
    config: { team, corp }
  } = useContext(AppContext);

  // Handler
  const handleSubmit = e => {
    e.preventDefault();
    if (email) {
      forgetPassword(team, corp, null, email, t);
    }
  };

  return (
    <Form className="mt-4" onSubmit={handleSubmit}>
      <Form.Group className="mb-3">
        <Form.Control
          placeholder={t('Email address')}
          value={email}
          name="email"
          onChange={({ target }) => setEmail(target.value)}
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Button className="w-100" type="submit" disabled={!email}>
          <Trans ns="auth">Send reset link</Trans>
        </Button>
      </Form.Group>
      <Link
        className="fs--1 text-600"
        to={`/${corp}/authentication/card/login`}
      >
        <span className="d-inline-block ms-1"> &larr;</span>
        <Trans ns="auth">Go back and try login again</Trans>
      </Link>
    </Form>
  );
};

ForgetPasswordForm.propTypes = {
  layout: PropTypes.string
};

ForgetPasswordForm.defaultProps = { layout: 'simple' };

export default ForgetPasswordForm;
